import React from 'react';
import {AppStore} from '~/QuickEcards/store';

export enum Step {
  CREATE = 'create',
  CUSTOMIZE = 'customize',
  EGIFT_CARD = 'egift-card',
  RECIPIENTS = 'recipients',
  RECIPIENTS_MESSAGE = 'recipients-message',
  REVIEW = 'review',
  SUCCESS = 'success',
  EXIT = 'exit',
}

export type StepMeta = {
  editing: boolean;
  creating: boolean;
  showBackButton: boolean;
  countSteps: boolean;
};

export type ButtonVariant = 'primary' | 'secondary';

export type StepConfig = {
  id: number;
  name?: Step;
  path: string;
  displayName?: string;
  meta?: StepMeta;
  nextRoute?: Step;
  previousRoute?: Step | ((store: AppStore) => Step) | null;
  saveOnLeave?: boolean;
  nextButtonText?: string | ((store: AppStore) => string);
  nextButtonVariant?: ButtonVariant | ((store: AppStore) => ButtonVariant);
  hideInWebView?: boolean;
  trackingLabel?: string;
  trackEGift?: boolean;
  showFooter?: boolean;
  showMegaNav?: boolean;
  overrideBottomNav?: boolean;
  preEnterRouteFunction?: (store: AppStore) => Promise<boolean>;
  preLeaveRouteFunction?: (store: AppStore) => Promise<boolean>;
  runPreLeaveForPrevious?: boolean;
  customButton?: (onClick: () => void, attrs: Record<string, unknown>) => React.ReactNode | null;
  headerCtas?: boolean;
};

export type Steps = Record<Step, StepConfig>;

export type Tab = 'design' | 'reveals' | 'effects';
export const TabNames: Record<Tab, string> = {
  design: 'Design Gallery',
  reveals: 'Reveals',
  effects: 'Effects',
};

export const SnapPoints = ['146px', '226px', '522px', 0.93];
export type SnapType = number | string | null;

export type OverlayIcon = {
  iconVp9: string;
  defaultSrc: string;
  iconH265: string;
  id: string;
};

export type DeepPartial<T> = {
  [P in keyof T]?: T[P] extends object ? DeepPartial<T[P]> : T[P];
};

export enum MessagesType {
  GLOBAL = 'All recipients',
  CUSTOM = 'Select recipients',
}
